module.exports = __webpack_public_path__ + "static/media/gazebo.9ab551a2.png";